// extracted by mini-css-extract-plugin
export default {"sapcnqr-skip-link":"sapcnqr-skip-link-e73832","sapcnqr-skip-link--list":"sapcnqr-skip-link--list-f8669c"};